import { useCallback, useEffect, useState } from "react";
import { FindItemIcon } from "../../../assets/icons";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { TextInput } from "../../../components/textInput/textInput";
import { Button } from "../../../components/button/button";
import { ProgressBar } from "../../../components/progressBar/progressBar";
import { useParams } from "react-router";
import { FileItem } from "./fileItem";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { usePopup } from "../../../components/popup/popup";
import AdminAPI from "../../../api/AdminAPI";
import KpiAPI from "../../../api/KpiAPI";

import styles from "./cafeKPIPage.module.css";
import { AddReport } from "./addReport";

import { Text } from "../../../components/text/text";

export const AdminCafeKPIPage = () => {
    const { cafeId } = useParams();
    const [search, setSearch] = useState("");
    const [files, setFiles] = useState([]);

    const curDate = new Date();

    const [type, setType] = useState(true);
    const [tasks, setTasks] = useState([]);

    const loadTasks = useCallback(async () => {
        if (!cafeId) return Promise.resolve();

        const res = await KpiAPI
            .fetchAdminKpiScheme(cafeId);
        return setTasks(res);
    }, [cafeId]);

    useEffect(() => {
        if (!type) return;
        loadTasks()
            .catch(console.error);
    }, [loadTasks, type]);

    useEffect(() => {
        if (type || !cafeId) return;
        AdminAPI
            .fetchReports(cafeId)
            .then(res => setFiles(res))
            .catch(console.error);
    }, [type, cafeId]);

    const openPage = useOpenPage();

    const onDelete = (id) => {
        KpiAPI
            .deleteKpiScheme(cafeId, id)
            .then(() => setTasks(prev => prev.filter(el => el.id !== id)))
            .catch(console.error);
    }

    const onDeleteAll = () => {
        KpiAPI
            .deleteAllKpiSchemes(cafeId, curDate.getMonth() + 1, curDate.getFullYear())
            .then(() => setTasks([]))
            .catch(console.error);
    }

    const [selectedTask, setSelectedTask] = useState(null);
    const [DeletePopup, openDeletePopup] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить план?",
        () => {
            if (!selectedTask?.id) return;
            onDelete(selectedTask.id);
        }
    );

    const [DeleteAllPopup, openDeleteAllPopup] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить все планы?",
        onDeleteAll
    );

    const [ActionPopup, openActionPopup, closeActionPopup] = usePopup();

    const onOpenTaskActions = (task) => {
        setSelectedTask(task);
        openActionPopup();
    }

    const onEditTask = () => {
        if (!selectedTask?.id) return;
        closeActionPopup();
        openPage(`edit/${selectedTask.id}`)();
    }

    const onDeleteTask = () => {
        closeActionPopup();
        openDeletePopup();
    }

    const onFileUploaded = (res) => {
        setFiles(prev => [...prev, res])
    }

    return (
        <>
            <AdminHeader title="Прогресс продаж" />

            <div className={styles.type_selector}>
                <Button view="thin" text="Прогресс" type={type ? "primary" : "secondary"} onClick={() => setType(true)} />
                <Button view="thin" text="Отчеты" type={!type ? "primary" : "secondary"} onClick={() => setType(false)} />
            </div>

            {
                !type &&
                <>
                    <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

                    <div className={styles.files_container}>
                        {
                            files.filter(el => el.originalFilename.toLowerCase().includes(search.toLowerCase().trim())).map(data => (
                                <FileItem key={data.id} data={data} onDeleteCallback={reportId => setFiles(prev => prev.filter(el => el.id !== reportId))} />
                            ))
                        }
                    </div>

                    <AddReport fileUploadedCallback={onFileUploaded} />
                </>
            }

            {
                type &&
                <>
                    <div className={styles.page_subtitle_container}>
                        <Text as="div" variant="h2" className={styles.page_subtitle} >Продажи по категориям</Text>
                        <Text as="div" variant="h2" className={styles.page_date} >{String(curDate.getDate()).padStart(2, "0")}.{String(curDate.getMonth() + 1).padStart(2, "0")}</Text>
                    </div>

                    <div className={styles.tasks_container}>
                        {
                            tasks.map(data =>
                                <ProgressBar
                                    key={data.id}
                                    date={data.kpiDate}
                                    title={data.categoryName}
                                    sold={data.completedRevenue}
                                    target={data.goalRevenue}
                                    onAction={() => onOpenTaskActions(data)}
                                />
                            )
                        }
                    </div>

                    <div className={styles.fixed_buttons}>
                        <Button
                            text="Добавить план"
                            onClick={openPage(`add`)}
                        />

                        <Button
                            text="Удалить все планы"
                            type="destructive"
                            onClick={openDeleteAllPopup}
                        />
                    </div>

                    <ActionPopup>
                        <Text as="div" variant="title" className={styles.popup_title} align="center">Действия</Text>
                        <div className={styles.popup_actions}>
                            <Button text="Редактировать" type="hint" onClick={onEditTask} />
                            <Button text="Удалить" type="destructive" onClick={onDeleteTask} />
                        </div>
                    </ActionPopup>

                    {DeletePopup}
                    {DeleteAllPopup}
                </>
            }
        </>
    )
}
